import { List } from '@mui/material'

import {
  GachaTicketOrdersConnectionFragment,
  Maybe,
} from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { TicketHistoryItem } from '@/components/organisms'
import { ScrollFetcher } from '@/components/organisms/functionals'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

export * from './fragments'

export type State = {
  loading: boolean
  hasNextPage: boolean
  gachaTicketOrders: Maybe<GachaTicketOrdersConnectionFragment>
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onFetchMore: () => Promise<void>
}

export const TicketOrdersTemplate: Template<State, Action> = ({
  state,
  onFetchMore,
}) => {
  const { t } = useTranslation('ticketOrders')
  const { routerNames, routerPages } = useRouter()

  return (
    <BaseLayout
      header={{
        back: true,
        defaultBackPage: routerPages.Wallet,
        title: t('title'),
      }}
    >
      <Head title={routerNames.TicketOrders} />
      <ScrollFetcher
        nodes={state.gachaTicketOrders?.edges.map(gachaTicket => (
          <TicketHistoryItem
            key={gachaTicket.node.id}
            gachaTicketOrder={gachaTicket.node}
          />
        ))}
        loading={state.loading}
        hasNextPage={state.hasNextPage}
        component={List}
        onFetchMore={onFetchMore}
      />
    </BaseLayout>
  )
}
